
import { Component, Prop, Vue } from 'vue-property-decorator';

import Model from './model';
import Common from "../commonUtil/common";

@Component
export default class MenuVue extends Vue {
  // @Prop() private msg!: string;
  private model = new Model();
  private common = new Common();

  private my_managerFlag: boolean = false;

  private userData = {
    id: '',
    username: '',
  }

  private created(){
    const myuser: any = this.common.getMyuser();
    this.userData.username = myuser.username;

    const flag = localStorage.getItem('my_managerFlag');
    // 如果等于字符串true，则设置成true
    if (flag === 'true') {
      this.my_managerFlag = true;
    }
  }


  // 登出
  private async logout() {
    localStorage.removeItem('myuser');
    localStorage.removeItem('my_managerFlag')
    this.model.logout({});
    this.$router.push('/login');
  }
}
